import React from 'react'
import Axios from "axios"
import Button from "../components/button"

const Newsletter = ({showMore=true, ...props}) => {
  const [email, setEmail] = React.useState("")
  const handleSubscribe = async (e) => {
    e.preventDefault()
    try {
      await Axios.post("https://api.sendinblue.com/v3/contacts", {
        email: email,
        listIds: [3]
      }, {
        headers: {
          "api-key": process.env.GATSBY_SENDINBLUE_API_KEY,
          "Content-Type": "application/json"
        }
      })
      setEmail("")
    } catch (error) {
      console.log(error)
    }
  }
  return (
    <div
      style={{
        display: "flex",
        background: "white",
        color: "black",
        flexDirection: "column",
        border: "1px solid black",
        borderRadius: "6px",
        padding: "30px",
      }}
      {...props}
    >
      <form
        style={{ marginBottom: "0", alignSelf: "center", textAlign: "center" }}
        onSubmit={handleSubscribe}
      >
        <p style={{ textAlign: "center", fontWeight: "extrabold" }}>
          Je partage chaque semaine des conseils pour les{" "}
          <b>Développeurs Freelance</b>
        </p>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <p style={{ marginBottom: 0 }}>Entrez votre adresse mail</p>
          <input
            type="email"
            value={email}
            onChange={e => {
              setEmail(e.target.value)
            }}
            placeholder="example@mail.fr"
            style={{
              border: "1px solid #E76F51",
              margin: "10px",
              width: "80%",
              textAlign: "center",
              padding: "5px",
            }}
            required
          />
        </div>
        <Button type="submit" width="100%" marginBottom="10px">
          Recevoir la Newsletter
        </Button>
      </form>
      {showMore && (
        <a
          target="_blank"
          rel="noreferrer"
          href={`https://www.cozy-codeur.fr/newsletter`}
          style={{ alignSelf: "center" }}
        >
          En savoir plus
        </a>
      )}
    </div>
  )
}
export default Newsletter